import { CssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { GlobalDesignAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';
import { BorderStyleValue } from '../common/lobby/types';
import compareColors from '../common/grouping/compare/compareColors';
import { MergingStrategyConfig } from '../common/grouping/types';
import defaultValueMergingStrategy from '../common/grouping/defaultValueMergingStrategy';

export const borderGrouping: GlobalDesignAction<'borderStyles'>['grouping'] = {
  getGroupingStrategy: (editorPointer, getHost) => {
    return () => {
      return groupByGroupDefinitions(editorPointer, 'borderStyles', getHost);
    };
  },

  applyValueMergingStrategy: (stylesGroups) => {
    const compareBorder = (
      value1: BorderStyleValue,
      value2: BorderStyleValue,
    ) => {
      return (
        // @ts-expect-error - TODO: ds-types-bump
        compareBorderWidth(value1?.width, value2?.width) &&
        // @ts-expect-error - TODO: ds-types-bump
        compareBorderStyle(value1?.style, value2?.style) &&
        // @ts-expect-error - TODO: ds-types-bump
        compareBorderColor(value1?.color, value2?.color)
      );
    };
    const compareBorderWidth = (
      value1: BorderStyleValue['width'],
      value2: BorderStyleValue['width'],
    ) =>
      // @ts-expect-error - TODO: ds-types-bump
      value1?.type === value2?.type && value1?.value === value2?.value;
    const compareBorderStyle = (
      value1: BorderStyleValue['style'],
      value2: BorderStyleValue['style'],
    ) =>
      // @ts-expect-error - TODO: ds-types-bump
      value1?.type === value2?.type && value1?.value === value2?.value;
    const compareBorderColor = (
      value1: BorderStyleValue['color'],
      value2: BorderStyleValue['color'],
    ) => compareColors(value1, value2);

    const config: MergingStrategyConfig<'borderStyles'> = {
      valueComparator: {
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.border]: compareBorder,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderWidth]: compareBorderWidth,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderStyle]: compareBorderStyle,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderColor]: compareBorderColor,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTop]: compareBorder,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTopColor]: compareBorderColor,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTopWidth]: compareBorderWidth,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTopStyle]: compareBorderStyle,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderRight]: compareBorder,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderRightColor]: compareBorderColor,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderRightWidth]: compareBorderWidth,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderRightStyle]: compareBorderStyle,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottom]: compareBorder,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottomColor]: compareBorderColor,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottomWidth]: compareBorderWidth,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottomStyle]: compareBorderStyle,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderLeft]: compareBorder,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderLeftColor]: compareBorderColor,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderLeftWidth]: compareBorderWidth,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderLeftStyle]: compareBorderStyle,
      },
      allowSubsets: true,
    };

    return defaultValueMergingStrategy<'borderStyles'>(stylesGroups, config);
  },
};
